import React from 'react';
import { Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  HistoryOutlined,
  LogoutOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

const SideNav = ({ onMenuSelect, onLogout, selectedKey = 'main' }) => {
  const menuItems = [
    {
      key: 'main',
      icon: <DashboardOutlined />,
      label: 'Main',
    },
    {
      key: 'videoroom',
      icon: <VideoCameraOutlined />,
      label: 'Video',
    },
    {
      key: 'history',
      icon: <HistoryOutlined />,
      label: 'History',
    },
  ];

  const logoutItem = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
    },
  ];

  const handleMenuClick = (e) => {
    if (onMenuSelect) {
      onMenuSelect(e.key);
    }
  };

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <Sider
      width={130}
      style={{
        height: '100vh',
        background: '#001529',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 1000,
      }}
      theme="dark"
      collapsible={false}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          background: '#fff',
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{
            flex: 1,
            borderRight: 0,
            paddingTop: '20px',
          }}
          items={menuItems}
          onClick={handleMenuClick}
          inlineCollapsed={true}
        />
        <Menu
          mode="inline"
          selectable={false}
          style={{
            borderRight: 0,
            paddingBottom: '20px',
          }}
          items={logoutItem}
          onClick={handleLogoutClick}
          inlineCollapsed={true}
        />
      </div>
    </Sider>
  );
};

export default SideNav;
